import styled from 'styled-components'

type Props = {
	hasError: boolean
	isDisabled: boolean
	isFocus: boolean
	isFocusVisible: boolean
	isHovered: boolean
	isReadOnly: boolean
}

export const InputContainer = styled.div<Props>`
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'text')};
	display: flex;
	justify-content: space-between;
	column-gap: 8px;
	background-color: ${({ isHovered, isFocusVisible, isDisabled, isFocus, isReadOnly, hasError, theme }) => {
		if (isDisabled || isReadOnly) return theme.color.input.code.disabledContrast
		if (isHovered || isFocusVisible || isFocus)
			return hasError ? theme.color.input.errorContrastHover : theme.color.input.code.background
		return hasError ? theme.color.input.errorContrast : theme.color.input.code.background
	}};
	border: 1px solid ${({ isHovered, isFocusVisible, isFocus, isDisabled, isReadOnly, hasError, theme }) => {
		if ((isHovered || isFocusVisible || isFocus) && !(isDisabled || isReadOnly))
			return hasError ? theme.color.input.error : theme.color.input.code.focus
		return hasError ? theme.color.input.error : theme.color.input.code.border
	}};
	border-radius: 6px;
	box-shadow: ${({ isFocusVisible, hasError, isDisabled, isReadOnly, theme }) => {
		if (isFocusVisible && !(isDisabled || isReadOnly))
			return hasError ? `0 0 0 2px ${theme.color.input.error} ` : `0 0 0 1px ${theme.color.input.code.focus}`
		return 'none'
	}};
	color: ${({ isReadOnly, isDisabled, theme }) => {
		if (isReadOnly || isDisabled) return theme.color.input.code.disabled
		return theme.color.input.code.text
	}};
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: 14px;
	margin: 0 0 -5px;
	outline: 0;
	padding: 6px;
	position: relative;
	text-align: left;
	transition: border 135ms ease, box-shadow 135ms ease, background-color 135ms ease;
	width: 100%;
	min-height: 22px;
`
